import React from 'react';
import { stateKeys } from '../constants/stateKeys';
import { useStateMethods } from '../providers/stateManager';

export const createOpenModal = (Component) => {
  return ({ onClick, ...props }) => {
    const { setValue } = useStateMethods();

    const handleClick = () => {
      setValue(stateKeys.visible, true);

      if (typeof onClick === 'function') {
        onClick();
      }
    };

    return <Component {...props} onClick={handleClick} />;
  };
};
